import $ from "jquery";
import React from "react";
import {connect} from "react-redux";
import {setSQFTActiveButton, setSQFTContextMenu} from "../../../../../../../actions/sqftMenuFunctions";
import SqftContextMenu from "../../shapes/overlays/sqftContextMenu";
import {injectIntl} from "react-intl";
import {
  BACKSPLASH_LABELS,
  CONTEXT_MENU_TYPE,
  COUNTERTOP_LABELS,
  SIDEBAR_NAVIGATION_BUTTONS
} from "../../../../../constants";
import config from "../../../store/sqftConfig";
import {updateSQFTCalculations} from "../../../../../../../actions/sqftFunctions";
import {initLabel, updateShape} from "./labelsHelper";
import {getCommonVisualizerType} from "../../../../../../../config";

const KITCHEN_CONTEXT_MENU_BUTTONS = [
  {
    partId: COUNTERTOP_LABELS.center_island_countertop,
    text:'sqft.contextmenu.labels.centerIsland'
  },
  {
    partId: COUNTERTOP_LABELS.countertop,
    text:'sqft.contextmenu.labels.countertop'
  },
  {
    partId: BACKSPLASH_LABELS.backsplash,
    text:'sqft.contextmenu.labels.backsplash'
  },
  // {
  //   partId: 'custom',
  //   text: 'sqft.contextmenu.labels.custom'
  // }
];

const BATHROOM_CONTEXT_MENU_BUTTONS = [
  {
    partId: COUNTERTOP_LABELS.vanity_countertop,
    text:'sqft.contextmenu.labels.countertop'
  },
  {
    partId: BACKSPLASH_LABELS.vanity_backsplash,
    text:'sqft.contextmenu.labels.backsplash'
  },
];

const SqftLabelsContextMenu = (props) => {
  const {contextMenu, setSQFTContextMenu, intl, updateCalculations, updateSQFTCalculations} = props;
  const CONTEXT_ACTIVE_MENU_NAME = "labels";
  const CONTEXT_MENU_BUTTONS = getCommonVisualizerType() === "bathroom" ? BATHROOM_CONTEXT_MENU_BUTTONS : KITCHEN_CONTEXT_MENU_BUTTONS;

  const handleContextMenuClicked = (e, item) => {
    switch (item.partId) {
      case 'custom' : {
        let popupId = 'label';
        var confirmPopup = popupId ? $('.message-box-overlay-' + popupId) : $('.message-box-overlay');
        confirmPopup.fadeIn(300);
        break;
      }
      default : {
        updateShape(item.partId, contextMenu.parent);
        initLabel(intl.formatMessage({id: item.text}), item.partId, contextMenu.parent);
        break;
      }
    }

    updateSQFTCalculations(updateCalculations + 1);
    setSQFTContextMenu({isOpened: false});
    setSQFTActiveButton(SIDEBAR_NAVIGATION_BUTTONS.move);
    config.workspace.menuItemActive = SIDEBAR_NAVIGATION_BUTTONS.move
  };

  //todo sqft-react
  // const saveCustomLabel = (e) => {
  //   void e;
  //   let text = $('[data-id="input-custom-label"]').val();
  //   updateShape(CUSTOM_LABEL);
  //   initLabel(text, CUSTOM_LABEL);
  // };

  const className = contextMenu.isOpened && contextMenu.activeMenu === CONTEXT_ACTIVE_MENU_NAME ? "" : "hidden";

  return (
    <div className={"labels-contextmenu " + className}>
      <SqftContextMenu
        handleItemClick={handleContextMenuClicked}
        pos={contextMenu.pos}
        contextMenuType={CONTEXT_MENU_TYPE.buttons}
        contextMenuButtons={CONTEXT_MENU_BUTTONS}/>
    </div>
  );
};

const mapStateToProps = (store) => ({
  contextMenu: store.sqftMenuState.contextMenu,
  updateCalculations: store.sqftState.updateCalculations,
  qtActiveCategory: store.qtState.qtActiveCategory,
});

const mapDispatchToProps = {
  setSQFTContextMenu,
  updateSQFTCalculations,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftLabelsContextMenu)
)
